import { JSX } from 'react';
import { cleanBoxProps } from '../../../utils/cleanBoxProps';

export const Div = ({
	children,
	onChange,
	id, //ignore it to avoid duplicate
	..._props
}: JSX.IntrinsicElements['div']) => {
	const props = cleanBoxProps(_props);
	return <div {...props}>{children}</div>;
};
